import { Suspense } from "react";
import { Navigate, Outlet } from "react-router";

import Layout from "@/Layout/Layout";

import { ChunkLoadErrorBoundary, Loader } from "@/components/commons";

const PageLoader = () => <Loader />;

const PrivateRoute = ({
  isLoggedIn,
  layoutProps,
}: {
  isLoggedIn: boolean;
  layoutProps: any;
}) => {
  return isLoggedIn ? (
    <Layout {...layoutProps}>
      <ChunkLoadErrorBoundary>
        <Suspense fallback={<PageLoader />}>
          <Outlet />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </Layout>
  ) : (
    <Navigate
      to="/login"
      replace
    />
  );
};

export default PrivateRoute;
